import { useEffect, useId, useState } from 'react'

const ZALO_URL = 'https://zalo.me/0935396912'
const ZALO_ICON =
  'https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Icon_of_Zalo.svg/960px-Icon_of_Zalo.svg.png'

export function ZaloFab() {
  const [open, setOpen] = useState(false)
  const titleId = useId()

  useEffect(() => {
    if (!open) return
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') setOpen(false)
    }
    document.addEventListener('keydown', onKey)
    const prev = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    return () => {
      document.removeEventListener('keydown', onKey)
      document.body.style.overflow = prev
    }
  }, [open])

  return (
    <>
      <button
        type="button"
        className="zalo-fab"
        title="Liên hệ Zalo"
        aria-label="Liên hệ Zalo"
        aria-haspopup="dialog"
        aria-expanded={open}
        onClick={() => setOpen(true)}
      >
        <img src={ZALO_ICON} alt="" className="zalo-fab-icon" width={34} height={34} />
      </button>

      {open ? (
        <div
          className="zalo-modal-backdrop"
          role="presentation"
          onClick={() => setOpen(false)}
        >
          <div
            className="zalo-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby={titleId}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="zalo-modal-head">
              <h2 id={titleId}>
                <i className="fa-solid fa-comments" aria-hidden /> Liên hệ Zalo
              </h2>
              <button
                type="button"
                className="zalo-modal-close btn-reset"
                aria-label="Đóng"
                onClick={() => setOpen(false)}
              >
                <i className="fa-solid fa-xmark" aria-hidden />
              </button>
            </div>
            <p>Zalo hỗ trợ khách hàng 24/7</p>
            <a
              className="btn btn-primary"
              href={ZALO_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fa-solid fa-arrow-up-right-from-square" aria-hidden /> Mở Zalo chat
            </a>
          </div>
        </div>
      ) : null}
    </>
  )
}
